import { useState } from 'react'
import { DatePicker } from '../GlobalComponents/DateInput/DateInput'

export const DatePickerStory = () => {
    var date = new Date()
    const tomorrow = date.setDate(date.getDate() + 1)
    const [value, setValue] = useState(new Date(tomorrow))
    return (
        <DatePicker
            minDate={new Date()}
            value={value}
            onChange={(newDate: any) => {
                setValue(newDate)
            }}
        />
    )
}
